/**
 * サブスクリプション状態管理
 */
import { create } from 'zustand';
const initialState = {
    subscription: null,
    tier: 'free',
    isLoading: false,
    error: null,
};
export const useSubscriptionStore = create((set) => ({
    ...initialState,
    setSubscription: (subscription) => set({
        subscription,
        tier: subscription?.subscription_tier ?? 'free',
        error: null,
    }),
    setLoading: (isLoading) => set({ isLoading }),
    setError: (error) => set({ error, isLoading: false }),
    reset: () => set(initialState),
}));
